<template>
  <div class="w-full h-full flex flex-col overflow-hidden">
    <user-info-box></user-info-box>
    <div class="open_vip" @click="openVip">
      <p>开通会员，享无限次使用次数</p>
      <div class="open_btn">立即开通</div>
    </div>
    <div class="center_box">
      <div class="center_body">
        <div class="center_item" @click="showFontPop">字号大小</div>
        <div class="center_item" @click="goorder">我的订单</div>
        <span @click="checkRule" class="center_item">MedliveGPT用户体验规则</span>
        <a href="https://m.medlive.cn/nsp/privacy.php?id=29" class="center_item">隐私说明</a>
      </div>
    </div>
    <div class="login_out" @click="loginOut">
      <div class="login_out_btn">退出登录</div>
    </div>

    <GoHomeBtn></GoHomeBtn>

    <div v-show="fontShow">
      <div class="font_box">
        <VuePicker :data="fontList"
          :showToolbar="true"
          @cancel="fontShow = false"
          @confirm="confirm"
          :visible.sync="fontShow"
        />
      </div>
    </div>
  </div>

</template>

<script>
// import { mapState, mapMutations } from "vuex";
import { mapMutations } from "vuex";
import UserInfoBox from "@/components/UserInfoBox.vue";
import VuePicker from 'vue-pickers';
import GoHomeBtn from "@/components/GoHomeBtn.vue";


export default {
  components: {
    UserInfoBox,
    VuePicker,
    GoHomeBtn,
  },
  data() {
    return {
      fontShow: false,
      fontList: [[
        { label: '小', value: 13 },
        { label: '中', value: 15 },
        { label: '大', value: 17 },
        { label: '超大', value: 19 },
        { label: '巨大', value: 26 }
      ]],
      fontSize: 15,
      fontIndex: 0,
    };
  },
  methods: {
    ...mapMutations(['setUserInfo', 'setFontSize']),
    loginOut() {
      window.location.href = `${process.env.VUE_APP_BASE_URL}/cas/logout?token=${window.localStorage.getItem('token')}`
      window.localStorage.removeItem('token')
      this.setUserInfo(null)
    },
    showFontPop() {
      this.fontShow = true
    },
    confirm(res) {
      console.log(res);
      this.fontSize = res[0].value
      this.fontShow = false
      this.setFontSize(this.fontSize)
    },
    openVip() {
      this.$router.push('/buyvip')
    },
    goorder() {
      this.$router.push({
        name: 'myorder'
      })
    },
    checkRule(){
      //  window.location.href = `${process.env.VUE_APP_BASE_URL}/web/agreement`
      //  window.open(this.$router.resolve({ name: 'agreement' }).href, '_blank')
      this.$router.push({
        name: 'agreement'
      })
    }
  }
};
</script>

<style lang='scss' scoped>
 .open_vip{
    background: url(@/assets/vip_bg.png) no-repeat right center;
    background-size: 100% auto;
    @apply w-auto h-12 pl-20 pr-4 mx-4 mb-[10px] flex justify-between items-center text-[11px] text-[#EAC59A];
    .open_btn{
      border-radius: 20px;
      background: linear-gradient(90deg, #D19C6C 0%, #EAC69B 50%, #DFAA7F 100%);
      @apply w-[70px] h-[22px] py-[3px] text-xs text-[#161616] text-center ;
    }
  }
  .center_box{
    @apply  flex-1 h-full mx-4 overflow-auto;
    .center_body{
      @apply  flex flex-col justify-center w-full px-5 bg-white rounded-[10px];
      .center_item{
        background: url(@/assets/icon_right.png) no-repeat right center;
        background-size: 6px 6px;
        border-bottom: 1px solid #C2C4CB;
        @apply text-base py-5;
        &:last-child {
          border-bottom: none;
        }
      }
    }
  }
  .login_out{
    @apply pb-5 text-center;
    .login_out_btn{
      @apply inline-block px-6 py-2 border border-[#A1A3AE] rounded-[10px] text-xs text-[#A1A3AE];
    }
  }
</style>
